import { TestReport, TestReportResponse } from '@/domains/test-report';
import { authorizedApi } from '@/services/network/authorized-api';

export const getAllTestReportNames = (userId: string) => authorizedApi.get<string[]>(`/test-reports/names`, { userId });

export const getAllTestReportsByWorkspaceName = (name: string) =>
  authorizedApi.get<TestReportResponse<TestReport>>(`/test-reports`, { name });

export const createTestReport = (data: TestReport) => authorizedApi.post<TestReport>(`/test-reports`, data);
